import React, { useState, useEffect } from 'react';

import FooterArt from 'components/FooterArt/FooterArt';
import Footer from 'components/FooterArt/Footer';
import { useSelector } from 'react-redux';
import SignIn from 'screens/SignInUp/SignIn';
import CustomModal from "components/CustomModal/CustomModal";

import { Preloader } from 'components/Preloader/Preloader';
import { getRequiredCoinRates } from 'services/general.service';

const Wrapper = ({ children, className, colors, id, setUsd }) => {

    const [showModal, setShowModal] = useState({ index: null, flag: false }); // for signInModal
    const state = useSelector(state => state);

    useEffect(() => {
        const interval = setInterval(() => {
            getRequiredCoinRates((res) => {
                setUsd(res.data);
            });
        }, 20000);
    
        return () => clearInterval(interval);        
    }, []);

    const setModalState = (index, flag) => {
        setShowModal({ index, flag });
    }

    return(

        <div id={id} className={`w-100 position-relative app-flex-column ${className}`} style={{ background: state?.theme === 'dark' ? colors?.darkBlack : colors?.white }}>

            <Preloader isDark={state?.theme === 'dark'} />

            {children}

            { !state?.user?.info && <FooterArt getStarted={() => setModalState(1, true)} /> }

            <Footer isLogin={state?.user?.isLogin && state?.user?.info} />

            <CustomModal show={showModal?.flag} handleClose={() => setModalState(0, false)} size={1}>
                <SignIn handleClose={(i, flag) => setModalState(i, flag)} currentTheme={null} defaultBehaviour={false} />
            </CustomModal>

        </div>

    );

}
 
export default Wrapper;